import { render, staticRenderFns } from "./FBMType.vue?vue&type=template&id=791ab7cc&scoped=true"
import script from "./FBMType.vue?vue&type=script&lang=js"
export * from "./FBMType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ab7cc",
  null
  
)

export default component.exports